/** BON-390: widen/narrow the search between the venue's region and all staff.
 *  A text action rather than a filter control — widening should read as a
 *  deliberate step out of the default region scoping. */
export function CrewPickerScopeToggle({
  allRegions,
  onToggle,
}: {
  allRegions: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      style={{
        alignSelf: 'flex-start',
        marginBottom: 8,
        padding: 0,
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        fontSize: 12,
        color: 'var(--nb-primary)',
      }}
    >
      {allRegions ? '‹ Back to staff in this region' : 'Search all staff instead ›'}
    </button>
  );
}
